module.exports = "/fonts/herculift.svg?e65ced6e4da9ce889f7e1c3f584842fb";